var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicnoteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_4988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8343 0.987364C28.5718 0.77927 28.2286 0.702415 27.9026 0.779056L9.26841 5.16356C9.02778 5.2203 8.81326 5.35645 8.65995 5.55021C8.50645 5.74417 8.42296 5.98395 8.42317 6.23123V20.4809H5.13479C3.56832 20.4809 2.12088 21.3165 1.33775 22.6731C0.554407 24.0298 0.554407 25.701 1.33775 27.0576C2.12088 28.4143 3.56832 29.2499 5.13479 29.2499H6.23092C7.39385 29.2499 8.509 28.7879 9.33131 27.9658C10.1534 27.1435 10.6154 26.0283 10.6154 24.8654V12.58L27.0573 8.71187V20.481H23.7689C22.2025 20.481 20.755 21.3166 19.9719 22.6732C19.1886 24.0299 19.1886 25.7011 19.9719 27.0577C20.755 28.4144 22.2025 29.25 23.7689 29.25H24.8651C26.028 29.25 27.1432 28.788 27.9655 27.9659C28.7876 27.1436 29.2496 26.0284 29.2496 24.8655V1.84683C29.2496 1.512 29.0967 1.19524 28.8343 0.987364Z",
    fill: "#F34E4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_4988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicnoteIcon);
export default __webpack_public_path__ + "static/media/musicnoteIcon.ab4ee85e6418844e29209f24ace36935.svg";
export { ForwardRef as ReactComponent };